// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase config — replace with your own from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyArFmPnzTfLrHFSyZWdEcDxGObepy6WTxc",
  authDomain: "appreact-3468b.firebaseapp.com",
  projectId: "appreact-3468b",
  storageBucket: "appreact-3468b.firebasestorage.app",
  messagingSenderId: "1067470302218",
  appId: "1:1067470302218:web:0c24434f7396cb590a83f3",
  measurementId: "G-MBC8YS47QJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);

